export const PROGRAMS_LIST_BOTTOM_PADDING = 10;
export const PROGRAMS_ITEMS_GRID_GAP = 20;
export const PROGRAM_PREFERENCES_LS_KEY = 'PROGRAM_PREFERENCES';
